export default __webpack_public_path__ + "static/media/css.9cfb5893.png";